// extracted by mini-css-extract-plugin
module.exports = {"root":"Phone_root__jPLho","screenImage":"Phone_screenImage__S6KIM","container":"Phone_container__3zILe","phone":"Phone_phone__NZb0a","screen":"Phone_screen__33zVP"};